
//未使用
import Cookies from 'js-cookie'
const user = {
    state: {
        nickName: Cookies.get('nickName') || null,
    },
    mutations: {
        SET_NICKNAME: (state, nickName) => {
            Cookies.set('nickName', nickName, { expires: 7 })
            state.nickName = nickName
        },
        DELETE_NICKNAME: (state) => {
            Cookies.remove('nickName')
            state.nickName = null
        },
    },
    actions: {
        deleteUserDataAction({ commit }) {
            commit('DELETE_NICKNAME')
        },
        //     setTokenAction({ commit }, token) {
        //         commit('SET_TOKEN', token)
        //     },
        //     deleteTokenAction({ commit }) {
        //         commit('DELETE_TOKEN')
        //     }
    }
}
export default user
